export const formatPrice = (val: any): string => {
  if (val == null) {
    return ''
  } else if (isNaN(val)) {
    return val
  } else {
    return `$${parseFloat(val).toFixed(2)}`
  }
}
